export const USERDATAADDRESS_DELETE_RESET = 'USERDATAADDRESS_DELETE_RESET'
export const USERDATAADDRESS_DELETE_SET_ERROR = 'USERDATAADDRESS_DELETE_SET_ERROR'
export const USERDATAADDRESS_DELETE_SET_DELETED = 'USERDATAADDRESS_DELETE_SET_DELETED'
export const USERDATAADDRESS_DELETE_TOGGLE_LOADING = 'USERDATAADDRESS_DELETE_TOGGLE_LOADING'
